// Pure helpers shared by the Reminder Setup tabs (no API, no React).

/** Pretty JSON for a read-only block or a JSON textarea ("" for null). */
export const toJsonText = (value) => (value === null || value === undefined ? "" : JSON.stringify(value, null, 2));

/** Parses a JSON-object textarea: "" -> null, an object -> it, anything else -> undefined (invalid). */
export function parseJsonObject(text) {
  if (!String(text ?? "").trim()) return null;
  try {
    const value = JSON.parse(text);
    return value !== null && typeof value === "object" && !Array.isArray(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

/** The server message of a failed request, or a fallback. */
export const errorMessage = (error, fallback = "Something went wrong.") => error?.response?.data?.message || fallback;

/** A save message that asks for a follow-up ("back in DRAFT: publish it again", "no REFERENCE field yet"). */
export const isCautionMessage = (message) => /DRAFT|REFERENCE|not published|publish it again/i.test(message ?? "");

/** A preview value as plain text ("—" when missing). Dates are rendered by the caller. */
export function formatValue(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return value.length ? value.map(String).join(", ") : "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
